import React, { useState } from "react";
import _ from "lodash";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import GoogleDocsPlaybackViewer from "./GoogleDocsPlaybackViewer";
import { setToastMsg } from "Login/modules/LoginModule";
import { useDispatch } from "Hooks/useDispatch";
import { fetchThirdPartyDriveAttachmentRevisionData } from "./modules/GoogleDocsPlaybackViewerModule";
import useMount from "Hooks/UseMount";

const GoogleDocsPlaybackWrapper = ({
  attachmentId,
  name,
  isViewerVisible,
  closePlaybackViewer,
  unmountPlaybackViewer,
  playbackButtonPositionStyle,
}) => {
  const dispatch = useDispatch();
  const [thirdPartyRevisionData, setThirdPartyRevisionData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useMount(() => {
    const fetchRevisionData = async () => {
      setIsLoading(true);

      const data =
        (await fetchThirdPartyDriveAttachmentRevisionData(attachmentId)) || {};
      setIsLoading(false);

      const { isSuccess = false, response, warning = "" } = data;

      if (isSuccess && !_.isEmpty(response)) {
        setThirdPartyRevisionData(response);
        return;
      }

      let toastMessage = "toastMsgs:something_went_wrong";
      switch (warning) {
        case "GOOGLE_ACCOUNT_NOT_LINKED":
          toastMessage = "toastMsgs:google_account_not_linked";
          break;
        case "USER_LACKS_REVISIONS_PERMISSION":
          toastMessage = "toastMsgs:need_edit_access_for_playback";
          break;
        case "UNSUPPORTED_FILE_TYPE":
          toastMessage = "toastMsgs:unsupported_document";
          break;
        default:
          break;
      }
      if (_.includes(_.toLower(warning), "file not found")) {
        toastMessage = "toastMsgs:file_not_found_in_google_connected_drive";
      }

      dispatch(
        setToastMsg({
          msg: toastMessage,
          type: "error",
          isClosable: true,
        })
      );
      //unmount in case of error, so that user can retry
      unmountPlaybackViewer();
    };

    fetchRevisionData();
  });

  const changeLog = _.get(thirdPartyRevisionData, "changeLog", []);
  const userMap = _.get(thirdPartyRevisionData, "userMap", {});

  return isLoading ? (
    <FullScreenLoader />
  ) : (
    <GoogleDocsPlaybackViewer
      name={name}
      isViewerVisible={isViewerVisible}
      closePlaybackViewer={closePlaybackViewer}
      isEmptyDocument={_.isEmpty(changeLog)}
      steps={changeLog}
      userMap={userMap}
      playbackButtonPositionStyle={playbackButtonPositionStyle}
    />
  );
};

export default GoogleDocsPlaybackWrapper;
